import { Dispatch, SetStateAction, useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationQuestionsKey,
  errorMessage,
  postJobPostingsQuestionsRoute,
  SubmitQuestion,
} from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';
import { updateWalkthroughStatus } from '@utils/updateOnboardingStatus';
import { useUpdateStatus } from '@features/profile/hooks/useUpdateStatus';

type UsePostApplicationQuestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const usePostApplicationQuestion = ({
  setErrorText = () => {},
}: UsePostApplicationQuestionProps) => {
  const { updateStatus } = useUpdateStatus({});
  const client = useQueryClient();

  const {
    mutate: postApplicationQuestion,
    isLoading: isPostApplicationQuestionLoading,
  } = useMutation({
    mutationFn: (variables: SubmitQuestion) =>
      axiosInstance
        .post(postJobPostingsQuestionsRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([applicationQuestionsKey]);
        client.invalidateQueries([profileKey]);
        if (data.user){
          updateWalkthroughStatus(data.user?.company?.plan, data.user, undefined, updateStatus);
        }
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { postApplicationQuestion, isPostApplicationQuestionLoading };
};
